import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.quote-slider').length) {

	var quoteSlider = new Swiper(".quote-slider .swiper", {
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 800,
		autoplay: {
			delay: 6000,
		},

    });

	$('.quote-slider .next').on('click', function() {
		quoteSlider.slideNext(1500);
	});

	$('.quote-slider .prev').on('click', function() {
		quoteSlider.slidePrev(1500);
	});

}

